export default class PayoutModel {
  constructor() {
    this._payouts = {}
  }

  setList(value, lines) {
    this._payouts = value

    Object.entries(this._payouts)
      .filter(([symbol]) => symbol !== '1')
      .forEach(([, pay]) => {
        for (let key in pay) {
          pay[key] /= lines
        }
      })
  }

  getList() {
    return this._payouts
  }
}
